<form class="row g-2 p-2" (ngSubmit)="searcheBenef()" #searchForm="ngForm">

  <!-- Search Input + Mode inline -->
  <div class="col-12 d-flex align-items-center gap-2">
    <div class="mode-switch flex-shrink-0" (click)="toggleMode()" title="Basculer : Mat ↔ CMU">
      <span class="mode-label">{{ searchModeLabel }}</span>
      <span class="mode-icon">⇄</span>
    </div>
    <input type="text" id="searchTextInput" class="form-control form-control-sm flex-grow-1" name="input_value"
      [(ngModel)]="input_value" [placeholder]="searchPlaceHolder" autocomplete="off" />
  </div>

  <!-- Buttons -->
  <div class="col-12 d-flex gap-2">
    <button class="btn btn-primary btn-sm flex-grow-1" type="submit" [disabled]="!input_value || isLoading">
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" style="width: 12px; height: 12px;"
        role="status" aria-hidden="true"></span>
      <i *ngIf="!isLoading" class="fa fa-search me-1" aria-hidden="true"></i>
      {{ isLoading ? 'Recherche...' : 'Rechercher' }}
    </button>
    <button *ngIf="searchAttempted" type="button" class="btn btn-outline-secondary btn-sm" (click)="resetSearch()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>

</form>